import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_3510_9789)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.0005 4.52898C14.3495 2.41998 17.9795 2.48998 20.2425 4.75698C22.5045 7.02498 22.5825 10.637 20.4785 12.993L11.9985 21.485L3.52052 12.993C1.41652 10.637 1.49552 7.01898 3.75652 4.75698C6.02152 2.49298 9.64452 2.41698 12.0005 4.52898ZM18.8265 6.16998C17.3265 4.66798 14.9065 4.60698 13.3365 6.01698L12.0015 7.21498L10.6655 6.01798C9.09052 4.60598 6.67552 4.66798 5.17152 6.17198C3.68152 7.66198 3.60652 10.047 4.97952 11.623L11.9995 18.654L19.0195 11.624C20.3935 10.047 20.3185 7.66498 18.8265 6.16998Z",
    fill: "#697076"
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_3510_9789" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "24",
      height: "24",
      fill: "white"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_icon_base = _resolveComponent("as-icon-base")!

  return (_openBlock(), _createBlock(_component_as_icon_base, {
    width: "24",
    height: "24",
    "view-box": "0 0 24 24"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }))
}